var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24329 0.340923C1.81524 0.50742 1.45325 0.729417 1.09126 1.09148C0.729268 1.4509 0.507317 1.81561 0.340854 2.24111C0.179675 2.65338 0.0713415 3.12645 0.0396341 3.81887C0.00792683 4.51128 0 4.73328 0 6.49868C0 8.26408 0.00792683 8.48607 0.0396341 9.17849C0.0713415 9.87091 0.182317 10.344 0.340854 10.7563C0.507317 11.1844 0.729268 11.5465 1.09126 11.9085C1.45325 12.2706 1.81524 12.4926 2.24329 12.6591C2.65549 12.8203 3.12846 12.9286 3.82073 12.9604C4.51301 12.9921 4.73496 13 6.5 13C8.26504 13 8.48699 12.9921 9.17927 12.9604C9.87154 12.9286 10.3445 12.8176 10.7567 12.6591C11.1848 12.4926 11.5467 12.2706 11.9087 11.9085C12.2707 11.5465 12.4927 11.1844 12.6591 10.7563C12.8203 10.344 12.9287 9.87091 12.9604 9.17849C12.9921 8.48607 13 8.26408 13 6.49868C13 4.73328 12.9921 4.51128 12.9604 3.81887C12.9287 3.12645 12.8177 2.65338 12.6591 2.24111C12.4927 1.81561 12.2707 1.4509 11.9114 1.09148C11.5494 0.729417 11.1874 0.50742 10.7593 0.340923C10.3472 0.179711 9.87419 0.071356 9.18191 0.0396422C8.48963 0.00792844 8.26768 0 6.50264 0C4.7376 0 4.51565 0.00792844 3.82337 0.0396422C3.12846 0.0687132 2.65549 0.179711 2.24329 0.340923ZM9.12642 1.20777C9.76057 1.23684 10.1041 1.34255 10.3339 1.4324C10.6378 1.55133 10.8545 1.6914 11.0817 1.91868C11.3089 2.14596 11.449 2.36268 11.5679 2.6666C11.6577 2.89652 11.7634 3.24009 11.7925 3.87436C11.8242 4.55885 11.8295 4.76499 11.8295 6.50132C11.8295 8.23765 11.8215 8.44379 11.7925 9.12828C11.7634 9.76255 11.6577 10.1061 11.5679 10.336C11.449 10.64 11.3089 10.8567 11.0817 11.084C10.8545 11.3112 10.6378 11.4513 10.3339 11.5702C10.1041 11.6601 9.76057 11.7658 9.12642 11.7949C8.44207 11.8266 8.23598 11.8319 6.5 11.8319C4.76403 11.8319 4.55793 11.8239 3.87358 11.7949C3.23943 11.7658 2.89594 11.6601 2.66606 11.5702C2.3622 11.4513 2.14553 11.3112 1.91829 11.084C1.69106 10.8567 1.55102 10.64 1.43211 10.336C1.34228 10.1061 1.23659 9.76255 1.20752 9.12828C1.17581 8.44379 1.17053 8.23765 1.17053 6.50132C1.17053 4.76499 1.17846 4.55885 1.20752 3.87436C1.23659 3.24009 1.34228 2.89652 1.43211 2.6666C1.55102 2.36268 1.69106 2.14596 1.91829 1.91868C2.14553 1.6914 2.3622 1.55133 2.66606 1.4324C2.89594 1.34255 3.23943 1.23684 3.87358 1.20777C4.55793 1.17605 4.76403 1.17077 6.5 1.17077C8.23598 1.17077 8.44207 1.17605 9.12642 1.20777Z",
    fill: "url(#paint0_linear_1286_120)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17073 6.5C3.17073 8.33993 4.66271 9.82927 6.5 9.82927C8.33729 9.82927 9.82927 8.33729 9.82927 6.5C9.82927 4.66271 8.33993 3.17073 6.5 3.17073C4.66007 3.17073 3.17073 4.66007 3.17073 6.5ZM8.66152 6.5C8.66152 7.69411 7.69411 8.66152 6.5 8.66152C5.30589 8.66152 4.33848 7.69411 4.33848 6.5C4.33848 5.30589 5.30589 4.33848 6.5 4.33848C7.69411 4.33848 8.66152 5.30589 8.66152 6.5Z",
    fill: "url(#paint1_linear_1286_120)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98781 3.80488C10.4256 3.80488 10.7805 3.44998 10.7805 3.0122C10.7805 2.57441 10.4256 2.21951 9.98781 2.21951C9.55002 2.21951 9.19512 2.57441 9.19512 3.0122C9.19512 3.44998 9.55002 3.80488 9.98781 3.80488Z",
    fill: "url(#paint2_linear_1286_120)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1286_120",
    x1: 13,
    y1: -3.8743e-7,
    x2: 6.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C12473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EC4C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#F7C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C75C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1286_120",
    x1: 13,
    y1: -3.8743e-7,
    x2: 6.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C12473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EC4C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#F7C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C75C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1286_120",
    x1: 13,
    y1: -3.8743e-7,
    x2: 6.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C12473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EC4C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#F7C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C75C"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.883881b1c20058096e8b5ea9f9ef0591.svg";
export { ForwardRef as ReactComponent };